// extracted by mini-css-extract-plugin
var _1 = "RequestStatusSelectInfo-moduleRequestStatusSelectInfo__Ngqk_";
var _2 = "RequestStatusSelectInfo-moduleplaceholder__xsybB";
var _3 = "RequestStatusSelectInfo-moduletext__KGqMT";
export { _1 as "RequestStatusSelectInfo", _2 as "placeholder", _3 as "text" }
